module.exports = __webpack_public_path__ + "static/media/m-operator-img-002.c994285b.jpg";